import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {Form, FormField, Button, Input, Textarea} from '../../../ui'
import {addCustomerComment, selectCustomer} from "../../../redux/slices/customer-slice";
import './style.css';

interface PropType {
  afterSubmit?: () => void;
}


export default function AddCommentView({ afterSubmit }: PropType) {

  const dispatch = useAppDispatch();
  const customer = useAppSelector(selectCustomer());
  const [commentSummary, setCommentSummary] = React.useState('');
  const [commentDescription, setCommentDescription] = React.useState('');

  const resetState = () => {
    setCommentSummary('');
    setCommentDescription('');
 };

  const handleAddComment= async () => {
    event.preventDefault();

    await dispatch(
      addCustomerComment({
          customerId: customer.id,
          summary: commentSummary,
          description: commentDescription,
        }
      )
    );

    resetState();

    // if there is afterSubmit function provided
    if (afterSubmit) {
      afterSubmit();
    }
  }

  return (
    <Form className="add-comment-form" floatingLabel testId="addCommentForm">
      <FormField labelForId="summary" labelText="Summary" type="input" testId="summaryField">
        <Input
          className='comment-input'
          id="summary"
          placeholder="Summary of the Comment"
          type="text"
          value={commentSummary}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCommentSummary(e.target.value)}
        />
      </FormField>

      <FormField labelForId="description" labelText="Description" type="input" testId="descriptionField">
        <Textarea
          id="description"
          placeholder="Description of the Comment"
          value={commentDescription}
          className='comment-textarea'
          onChange={event => setCommentDescription(event.target.value)}
        />
      </FormField>

      <Button
        className='blue-button'
        testId='addCommentButton'
        onClick={handleAddComment}
        type='submit'
        title='Add Comment'>Add Comment</Button>
    </Form>
  )
}
